import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Calculator, Menu, X } from 'lucide-react';
import { LocaleLink } from '@/components/LocaleLink';
import { useLocale } from '@/hooks/useLocale';
import { SUPPORTED_LANGS, LANG_LABELS } from '@/i18n';
import { CalculatorLink, HowItWorksLink, MethodologyLink } from './LandingActions';

export const LandingNavigation = () => {
  const { t } = useTranslation();
  const { lang, switchLanguage } = useLocale();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (open) document.querySelector('#landing-navigation a')?.focus();
  }, [open]);
  const close = () => setOpen(false);
  return <header className="lp-header" data-testid="landing-header" onKeyDown={e => {
    if (e.key === 'Escape') { close(); document.getElementById('landing-menu-toggle')?.focus(); }
  }}>
    <a className="skip-nav-link" href="#landing-main" data-testid="landing-skip-link">{t('homepage.skip')}</a>
    <div className="lp-container lp-nav-row">
      <LocaleLink to="/" className="lp-brand" data-testid="landing-brand" onClick={close}>
        <Calculator size={23} aria-hidden="true" /><span>ISMSCalculator</span>
      </LocaleLink>
      <nav id="landing-navigation" aria-label={t('homepage.navigation')} className={`lp-nav-links ${open ? 'is-open' : ''}`}
        data-testid="landing-navigation">
        <CalculatorLink placement="navigation" textOnly onClick={close}>{t('nav.calculator')}</CalculatorLink>
        <HowItWorksLink placement="navigation" onClick={close} />
        <MethodologyLink placement="navigation" onClick={close}>{t('footer.methodology')}</MethodologyLink>
        <LocaleLink to="/blog" data-testid="landing-nav-blog" onClick={close}>{t('footer.blog')}</LocaleLink>
        <LocaleLink to="/auth" data-testid="landing-nav-signin" onClick={close}>{t('nav.signIn')}</LocaleLink>
      </nav>
      <div className="lp-nav-controls">
        <select value={lang} aria-label={t('homepage.language')} data-testid="landing-language"
          onChange={e => { close(); switchLanguage(e.target.value); }}>
          {SUPPORTED_LANGS.map(code => <option key={code} value={code} lang={code} data-testid={`landing-language-${code}`}>{LANG_LABELS[code]}</option>)}
        </select>
        <button id="landing-menu-toggle" type="button" className="lp-menu-toggle" aria-label={t('nav.menu')}
          aria-expanded={open} aria-controls="landing-navigation" data-testid="landing-menu-toggle" onClick={() => setOpen(!open)}>
          {open ? <X size={21} aria-hidden="true" /> : <Menu size={21} aria-hidden="true" />}
        </button>
      </div>
    </div>
  </header>;
};